import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { reverse } from 'named-urls';
import { isStaff } from '@achievable-me/tundra-wizard/auth';
import routes from '@achievable-me/tundra-wizard/routes';
import storage from '$lib/storage';

class Bounce extends Component {
  render() {
    const { currentUser } = this.props;

    const returnTo = storage.getReturnTo();
    if (returnTo) {
      storage.clearReturnTo();
      return <Redirect to={returnTo} />;
    }

    if (isStaff(currentUser)) {
      return <Redirect to={routes.staff.dashboard} />;
    }

    const { activeProductSlug } = currentUser;

    if (!activeProductSlug || activeProductSlug === 'achievable') {
      return (
        <Redirect to={reverse(routes.study.catalog, { productSlug: 'achievable' })} />
      );
    }

    return (
      <Redirect
        to={reverse(routes.study.dashboard, { productSlug: activeProductSlug })}
      />
    );
  }
}

export default Bounce;
